'use client';

import { GlobalErrorPage, type GlobalErrorProps } from '@libs/shared-ui';

export default function GlobalError({ reset, error }: GlobalErrorProps) {
    return <GlobalErrorPage reset={reset} error={error} />;
}
